import { dataHook } from '../../utils'
// @ts-ignore
import classes from './text-button.css'

const chevron = `<svg class="${classes.chevron}" viewBox="0 0 24 24" fill="currentColor" width="24" height="24"><path d="M9.14644661,8.14512634 C9.34170876,7.9498642 9.65829124,7.9498642 9.85355339,8.14512634 L14.206596,12.5 L9.85355339,16.8536987 C9.65829124,17.0489609 9.34170876,17.0489609 9.14644661,16.8536987 C8.95118446,16.6584366 8.95118446,16.3418541 9.14644661,16.1465919 L12.7923824,12.5 L9.14644661,8.85223312 C8.95118446,8.65697098 8.95118446,8.34038849 9.14644661,8.14512634 Z"></path></svg>`
export const textButtonTemplate = (
  body: string,
  hook = '',
  ariaAttr?: string,
) =>
  `<button class="${classes.button}" ${dataHook(
    hook,
  )} ${ariaAttr}><span class="${
    classes.text
  }">${body}</span>${chevron}</button>`
